import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import heroBackground from '../../../../assests/images/help/ayuda_background.svg';
import { HELP_TITLE_CLASS, helpColors, helpFonts } from '../style/helpStyles';

const HEADER_MOBILE_HEIGHT = 50;

const chipBaseSx = {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '16px',
  fontWeight: 700,
  color: helpColors.pink,
  backgroundColor: helpColors.white,
  boxShadow: '0 12px 24px -10px rgba(218,0,103,0.30)',
  userSelect: 'none',
};

const chipTiltedSx = (deg) => ({
  transform: `rotate(${deg}deg)`,
  boxShadow: '0 2px 6px rgba(31,27,29,0.06), 0 18px 34px -12px rgba(218,0,103,0.42)',
});

const HelpHero = ({ isMobile }) => (
  <Box
    component="section"
    sx={{
      position: 'relative',
      overflow: 'hidden',
      textAlign: 'center',
      backgroundColor: '#FFF5EE',
      backgroundImage: `url(${heroBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: isMobile ? '56px 20px 48px' : '80px 24px 72px',
      '@media (max-width:599.95px)': { marginTop: `${HEADER_MOBILE_HEIGHT}px` },
    }}
  >
    <Box sx={{
      ...chipBaseSx,
      width: 46,
      height: 46,
      fontSize: 22,
      top: isMobile ? 28 : 40,
      left: isMobile ? 26 : '10%',
      ...chipTiltedSx(-12),
    }}
    >
      ?
    </Box>
    <Box
      sx={{
        ...chipBaseSx,
        width: 40,
        height: 40,
        fontSize: 19,
        top: isMobile ? 112 : 148,
        right: isMobile ? 30 : '10%',
        ...chipTiltedSx(12),
      }}
    >
      ?
    </Box>

    <Box sx={{
      position: 'relative', zIndex: 2, maxWidth: 720, margin: '0 auto',
    }}
    >
      <Typography
        component="span"
        sx={{
          display: 'inline-block',
          fontWeight: 600,
          fontSize: isMobile ? 12 : 14,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: helpColors.pink,
          backgroundColor: helpColors.pink50,
          padding: '7px 14px',
          borderRadius: '999px',
          marginBottom: '18px',
        }}
      >
        {i18n.helpHeroEyebrow}
      </Typography>
      <Typography
        variant="h1"
        className={HELP_TITLE_CLASS}
        sx={{
          fontFamily: helpFonts.title,
          fontWeight: 700,
          letterSpacing: '-0.035em',
          lineHeight: 1,
          color: helpColors.ink,
          // 96 es el tamaño que ya venía dando responsiveFontSizes; explícito para no cambiarlo.
          fontSize: isMobile ? 52 : 96,
        }}
      >
        {i18n.footerHelp}
      </Typography>
      <Typography
        component="p"
        sx={{
          margin: '16px auto 0',
          maxWidth: isMobile ? 300 : 460,
          fontSize: isMobile ? 16 : 20,
          lineHeight: 1.45,
          color: helpColors.ink2,
        }}
      >
        {i18n.helpSubtitle}
      </Typography>
    </Box>
  </Box>
);

HelpHero.propTypes = {
  isMobile: PropTypes.bool,
};

HelpHero.defaultProps = {
  isMobile: false,
};

export default HelpHero;
